import { createSlice } from "@reduxjs/toolkit";

export const attachedfileSlice = createSlice({
  name: "attachedfile",
  initialState: {
    value: null,
    list: [],
    uploadfileinfo:null
  },
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = null;
    },
    set: (state, action) => {
      state.value = action.payload;
    },
    setUploadfileInfo :(state,action) =>{
      state.uploadfileinfo = action.payload
    }
  },
});

export const { clear, set,setUploadfileInfo } = attachedfileSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectAttachedfile = (state) => state.attachedfile.value;
export const getListofAttachedfile = (state) => state.attachedfile.list;
export const getUploadFileInfo = (state) => state.attachedfile.uploadfileinfo;
export default attachedfileSlice.reducer;
